import { render } from "./CrossCountryFIACSpecsRules.vue?vue&type=template&id=019b813e"
import script from "./CrossCountryFIACSpecsRules.vue?vue&type=script&lang=js"
export * from "./CrossCountryFIACSpecsRules.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__